export class loginData {
    username: string;
    password: string;
}